export const themes = {
  Default: {
    '--background-primary': '#0eafb5',
    '--background-secondary': '#0ca1a6',
    '--background-tertiary': '#0eafb5',
    '--foreground-color-primary': '#777777',
    '--foreground-color-secondary': '#0eafb5',
    '--btn-apportis-color': '#418d84',
    '--btn-apportis-secondary': '#56b0b6',
    '--btn-close-color': '#903737',
    '--background-menu-active': '#133031',
    '--btn-hover-color': '#777777',
  },
  Blue: {
    '--background-primary': '#0747A6',
    '--background-secondary': '#0065FF',
    '--background-tertiary': '#0747A6',
    '--foreground-color-primary': '#777777',
    '--foreground-color-secondary': '#0747A6',
    '--btn-apportis-color': '#0052CC',
    '--btn-apportis-secondary': '#3572b0',
    '--btn-close-color': '#903737',
    '--background-menu-active': '#060110',
    '--btn-hover-color': '#777777',
  },
  Dark: {
    '--background-primary': '#121212',
    '--background-secondary': '#BB86FC',
    '--background-tertiary': '#121212',
    '--foreground-color-primary': '#777777',
    '--foreground-color-secondary': '#121212',
    '--btn-apportis-color': '#FF0266',
    '--btn-apportis-secondary': '#616161',
    '--btn-close-color': '#903737',
    '--background-menu-active': '#BB86FC',
    '--btn-hover-color': '#777777',
  },
  Cyan: {
    '--background-primary': '#156734',
    '--background-secondary': '#eecb14',
    '--background-tertiary': '#156734',
    '--foreground-color-primary': '#777777',
    '--foreground-color-secondary': '#156734',
    '--btn-apportis-color': '#9D7D35',
    '--btn-apportis-secondary': '#156734',
    '--btn-close-color': '#903737',
    '--background-menu-active': '#eecb14',
    '--btn-hover-color': '#777777',
  },
  StrongRed: {
    '--background-primary': '#cc0033',
    '--background-secondary': '#c9c9c9',
    '--background-tertiary': '#666666 ',
    '--foreground-color-primary': '#777777',
    '--foreground-color-secondary': '#cc0033',
    '--btn-apportis-color': '#666666',
    '--btn-apportis-secondary': '#cc0033',
    '--btn-close-color': '#903737',
    '--background-menu-active': '#df184a',
    '--btn-hover-color': '#777777',
  },
  DarkRed: {
    '--background-primary': '#a99df2',
   '--background-secondary': '#EDE9FE',
   '--background-tertiary': '#a99df2',
   '--foreground-color-primary': '#1F1F1F',
   '--foreground-color-secondary': '#5B21B6',
   '--btn-apportis-color': '#8B5CF6',
   '--btn-apportis-secondary': '#6D28D9',
   '--btn-close-color': '#EF4444',
   '--background-menu-active': '#4b3f95',
   '--btn-hover-color': '#7C3AED',
  },
  Pearson: {
    '--background-primary': '#2d803a',
    '--background-secondary': '#be9539',
    '--background-tertiary': '#1a1a18',
    '--foreground-color-primary': '#777777',
    '--foreground-color-secondary': '#2d803a',
    '--btn-apportis-color': '#1a1a18',
    '--btn-apportis-secondary': '#2d803a',
    '--btn-close-color': '#903737',
    '--btn-hover-color': '#be9539',
    '--background-menu-active': '#be9539',
  },
  OhioUniversity: {
    '--background-primary': '#00694E',
    '--background-secondary': '#21b173',
    '--background-tertiary': '#00694E',
    '--foreground-color-primary': '#777777',
    '--foreground-color-secondary': '#00694E',
    '--btn-apportis-color': '#93a89e',
    '--btn-apportis-secondary': '#00694E',
    '--btn-close-color': '#903737',
    '--btn-hover-color': '#00694E',
    '--background-menu-active': '#05ee8a',
    },
  Crosswinds: {
    '--background-primary': '#301e80',
    '--background-secondary': '#FF573D',
    '--background-tertiary': '#301e80',
    '--foreground-color-primary': '#301e80',
    '--foreground-color-secondary': '#FF573D',
    '--btn-apportis-color': '#FF573D',
    '--btn-apportis-secondary': '#301e80',
    '--btn-close-color': '#FF573D',
    '--background-menu-active': '#FF573D',
    '--btn-hover-color': '#301e80',
  },
  ClaymontSchools: {
    '--background-primary': '#f26722',
    '--background-secondary': '#4f2800',
    '--background-tertiary': '#f26722',
    '--foreground-color-primary': '#f26722',
    '--foreground-color-secondary': '#4f2800',
    '--btn-apportis-color': '#4f2800',
    '--btn-apportis-secondary': '#f26722',
    '--btn-close-color': '#4f2800',
    '--background-menu-active': '#4f2800',
    '--btn-hover-color': '#f26722',
  },
  WrightState: {
    '--background-primary': '#046A38',
    '--background-secondary': '#CBA052',
    '--background-tertiary': '#046A38',
    '--foreground-color-primary': '#046A38',
    '--foreground-color-secondary': '#CBA052',
    '--btn-apportis-color': '#CBA052',
    '--btn-apportis-secondary': '#046A38',
    '--btn-close-color': '#CBA052',
    '--background-menu-active': '#CBA052',
    '--btn-hover-color': '#046A38',
  },
  DarkGrey: {
    '--background-primary': '#212529',
    '--background-secondary': '#D3D3D3',
    '--background-tertiary': '#212529',
    '--foreground-color-primary': '#212529',
    '--foreground-color-secondary': '#212529',
    '--btn-apportis-color': '#D3D3D3',
    '--btn-apportis-secondary': '#212529',
    '--btn-close-color': '#CBA052',
    '--background-menu-active': '#CBA052',
    '--btn-hover-color': '#212529',
  },
  NP: {
    '--background-primary': '#be1717',
    '--background-secondary': '#242323',
    '--background-tertiary': '#be1717',
    '--foreground-color-primary': '#be1717',
    '--foreground-color-secondary': '#242323',
    '--btn-apportis-color': '#242323',
    '--btn-apportis-secondary': '#be1717',
    '--btn-close-color': '#242323',
    '--background-menu-active': '#242323',
    '--btn-hover-color': '#be1717',
  },
  CAPE: {
    '--background-primary': '#140F38',
    '--background-secondary': '#ee0000',
    '--background-tertiary': '#140F38',
    '--foreground-color-primary': '#140F38',
    '--foreground-color-secondary': '#ee0000',
    '--btn-apportis-color': '#ee0000',
    '--btn-apportis-secondary': '#140F38',
    '--btn-close-color': '#ee0000',
    '--background-menu-active': '#ee0000',
    '--btn-hover-color': '#140F38',
  },
  Miami: {
    '--background-primary': '#ad102a',
    '--background-secondary': '#c31425',
    '--background-tertiary': '#ad102a',
    '--foreground-color-primary': '#c31425',
    '--foreground-color-secondary': '#c31425',
    '--btn-apportis-color': '#413025',
    '--btn-apportis-secondary': '#c31425',
    '--btn-close-color': '#c31425',
    '--background-menu-active': '#413025',
    '--btn-hover-color': '#c31425',
  },
  NorthAllegheny: {
    '--background-primary': '#d39800',
    '--background-secondary': '#171717',
    '--background-tertiary': '#d39800',
    '--foreground-color-primary': '#171717',
    '--foreground-color-secondary': '#171717',
    '--btn-apportis-color': '#171717',
    '--btn-apportis-secondary': '#171717',
    '--btn-close-color': '#d39800',
    '--background-menu-active': '#171717',
    '--btn-hover-color': '#d39800',
  },
  Carlow: {
    '--background-primary': '#3c1053',
    '--background-secondary': '#f1c400',
    '--background-tertiary': '#3c1053',
    '--foreground-color-primary': '#3c1053',
    '--foreground-color-secondary': '#3c1053',
    '--btn-apportis-color': '#f1c400',
    '--btn-apportis-secondary': '#f1c400',
    '--btn-close-color': '#f1c400',
    '--background-menu-active': '#f1c400',
    '--btn-hover-color': '#d39800',
  }
};
